import tw from "tailwind-styled-components";
import { MdClose } from "react-icons/md";
import moment from "moment";
import { ActionSection, EditButton, ModalContainer, ModalContent, ModalHeader, ModalRow, ModalRowLabel, ModalRowValue, ModalSection, ModalSectionTitle, ScrollableContent, SideCancelBtn, SubContainer, SubmitBtn } from "../Styles/InputStyles";
import { capitalizeFirstLetter, getDueTypeLabel } from "../../helpers";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import ModalProfileHeader from "../Common/ModalProfileHeader";

const ViewDetails = ({
    setShowDueDetails,
    selectedData,
    setIsEditDues,
    showNotesModal,
    setShowNotesModal,
    handleSaveNotes,
    addEditRemarkLoading,
    addEditRemarkMutate,
    canEditDues
}) => {

    const onClose = () => {
        setShowDueDetails(false);
        setShowNotesModal(false)
    };

    const desc = selectedData?.description ? selectedData?.description : '-';

    return (
        <>
            <ModalContainer>
                <ModalHeader>
                    <h1 className="text-white text-lg font-medium">Due Details</h1>
                    <button onClick={onClose}>
                        <MdClose color="white" size={24} />
                    </button>
                </ModalHeader>
                <ModalProfileHeader
                    title="Due Details"
                    name={capitalizeFirstLetter(selectedData?.tenantName)}
                    subtitle={`#${selectedData?.roomNum} • ${selectedData?.flatName} • ${selectedData?.propertyName}`}
                    amount={selectedData?.balance}
                    image={selectedData?.profilePicture}
                    onClose={onClose}
                />
                <ModalContent>
                    <ScrollableContent>
                        <Wrapper>
                            <BtnWrapper>
                                <ModalSectionTitle>Due Details</ModalSectionTitle>
                                {canEditDues &&
                                    <EditButton
                                        title="Edit Basic Detail"
                                        onClick={() => {
                                            setShowDueDetails(false);
                                            setIsEditDues(true);
                                        }}
                                    >
                                        Edit
                                    </EditButton>
                                }
                            </BtnWrapper>
                            <ModalSection>
                                <ModalRow className="mb-3">
                                    <FlexCol>
                                        <ModalRowLabel>Type</ModalRowLabel>
                                        <ModalRowValue>{selectedData?.type ? getDueTypeLabel((selectedData?.type)) : selectedData?.title}</ModalRowValue>
                                    </FlexCol>
                                    <FlexCol>
                                        <ModalRowLabel>Duration</ModalRowLabel>
                                        <ModalRowValue>
                                            {selectedData?.rentStartDate && selectedData?.rentEndDate
                                                ? `${moment(selectedData.rentStartDate).format('DD, MMM YY')} - ${moment(
                                                    selectedData.rentEndDate
                                                ).format('DD, MMM YY')}`
                                                : '-'}
                                        </ModalRowValue>

                                    </FlexCol>

                                </ModalRow>
                                <ModalRow className="mb-3">
                                    <FlexCol>
                                        <ModalRowLabel>Due Date</ModalRowLabel>
                                        <ModalRowValue>{moment(selectedData?.dueDate).format("DD, MMM YYYY")}</ModalRowValue>
                                    </FlexCol>
                                    <FlexCol>
                                        <ModalRowLabel>Created At</ModalRowLabel>
                                        <ModalRowValue>{moment(selectedData?.createdAt).format("DD, MMM YYYY")}</ModalRowValue>
                                    </FlexCol>
                                </ModalRow>
                                {getDueTypeLabel((selectedData?.type)) === 'OTHER' &&
                                    <ModalRow className="mb-3">
                                        <FlexCol>
                                            <ModalRowLabel>Title</ModalRowLabel>
                                            <ModalRowValue>{selectedData?.title || ''}</ModalRowValue>
                                        </FlexCol>
                                    </ModalRow>
                                }
                                <div className="flex flex-col mb-3 py-3">
                                    <FlexCol>
                                        <ModalRowLabel>Description</ModalRowLabel>
                                        <ModalRowValue>{desc}</ModalRowValue>
                                    </FlexCol>
                                </div>
                            </ModalSection>

                            <BtnWrapper>
                                <ModalSectionTitle>Payment Summary</ModalSectionTitle>
                            </BtnWrapper>
                            <ModalSection>
                                <ModalRow>
                                    <ModalRowLabel>Total Due</ModalRowLabel>
                                    <ModalRowValue className='ml-auto'>{'₹' + selectedData?.amount}</ModalRowValue>
                                </ModalRow>
                                <ModalRow className="mb-2 border-b border-dashed">
                                    <ModalRowLabel>Paid</ModalRowLabel>
                                    <ModalRowValue className='ml-auto'>{'₹' + (Number(selectedData?.amount) - Number(selectedData?.balance))}</ModalRowValue>
                                </ModalRow>
                                <ModalRow>
                                    <ModalRowLabel>Balance</ModalRowLabel>
                                    <ModalRowValue className="ml-auto">{'₹' + selectedData?.balance}</ModalRowValue>
                                </ModalRow>
                            </ModalSection>

                            {selectedData?.dueImages?.length > 0 && (
                                <div >
                                    <ModalSectionTitle>Due Images</ModalSectionTitle>
                                    <div className="mt-3 flex gap-3 flex-wrap pb-2">
                                        {selectedData.dueImages.map((image) => (
                                            <button
                                                key={image.id}
                                                type="button"
                                                onClick={() => window.open(image.value, "_blank")}
                                                className="relative shrink-0 group"
                                            >
                                                <img
                                                    src={image.value}
                                                    alt="Due"
                                                    className="
                                                    w-28
                                                    h-28
                                                    rounded-xl
                                                    object-cover
                                                    border
                                                    border-gray-200
                                                    shadow-sm
                                                    transition-all
                                                    duration-300
                                                    group-hover:scale-105
                                                    group-hover:shadow-lg
                                                "
                                                />

                                                <div
                                                    className="
                                                    absolute
                                                    inset-0
                                                    rounded-xl
                                                    bg-black/0
                                                    group-hover:bg-black/10
                                                    transition
                                                "
                                                />
                                            </button>
                                        ))}
                                    </div>
                                </div>
                            )}

                        </Wrapper>
                    </ScrollableContent>
                </ModalContent>
            </ModalContainer>

            {/* Notes Modal */}
            {showNotesModal && (
                <NotesModal
                    selectedData={selectedData}
                    setShowNotesModal={setShowNotesModal}
                    setShowDueDetails={setShowDueDetails}
                    handleSaveNotes={handleSaveNotes}
                    addEditRemarkLoading={addEditRemarkLoading}
                    addEditRemarkMutate={addEditRemarkMutate}
                />
            )}
        </>
    );
};

// Notes Modal Component
const NotesModal = ({
    selectedData,
    setShowNotesModal,
    setShowDueDetails,
    handleSaveNotes,
    addEditRemarkMutate,
    addEditRemarkLoading

}) => {

    const initialValues = {
        remarks: selectedData?.remarks || "",
        id: selectedData?.tenantId
    };

    const validationSchema = Yup.object().shape({
        remarks: Yup.string()
            .required("Remarks is required")
            .max(500, "Remarks must be 500 characters or less")
    });

    const onSubmit = (values) => {
        addEditRemarkMutate({
            remarks: values.remarks,
            id: values.id
        });
        // setShowNotesModal(false);
        // setShowDueDetails(true);
    };

    const onClose = () => {
        setShowNotesModal(false);
        setShowDueDetails(true);
    };

    return (
        <SubContainer>
            <ModalContainer>
                <Header>
                    <Title>  {selectedData?.remarks ? "Edit Notes" : "Add Notes"}</Title>
                    <button onClick={onClose}>
                        <MdClose color="white" size={24} />
                    </button>
                </Header>
                <ModalContent>
                    <ScrollableContent>
                        <Wrapper>

                            <Formik
                                initialValues={initialValues}
                                validationSchema={validationSchema}
                                onSubmit={onSubmit}
                            >
                                {({ isSubmitting }) => (
                                    <StyledForm>
                                        {/* <ModalBody> */}
                                        <Field
                                            as="textarea"
                                            name="remarks"
                                            placeholder="Enter your remarks here..."
                                            className="w-full p-2 border border-gray-300 rounded-md h-32"
                                        />
                                        <ErrorMessage
                                            name="remarks"
                                            component="div"
                                            className="text-red-500 text-sm mt-1"
                                        />
                                        {/* </ModalBody> */}

                                        <ActionSection>
                                            <SideCancelBtn type="button" onClick={() => {

                                                onClose();
                                            }
                                            }>
                                                Cancel
                                            </SideCancelBtn>
                                            <SubmitBtn type="submit" disabled={addEditRemarkLoading}>
                                                {addEditRemarkLoading ? "Submitting..." : "Submit"}
                                            </SubmitBtn>
                                        </ActionSection>
                                    </StyledForm>
                                )}
                            </Formik>
                        </Wrapper>
                    </ScrollableContent>
                </ModalContent>
            </ModalContainer>
        </SubContainer>
    );
};



// Styled components for the modal
// const ModalContainer = tw.div`fixed inset-0 bg-black/40 backdrop-blur-sm flex items-center justify-center z-50`;
// const ModalBody = tw.div`p-4`;
const StyledForm = tw(Form)`flex flex-col`;
//const Header = tw.div`flex items-center justify-between bg-[#0078BD] py-4 px-4`;
const Header = tw.div`
flex items-center justify-between
px-6 py-5
border-b border-gray-100
bg-white
`;
const Wrapper = tw.div`grid gap-2 my-0`;
const Title = tw.h1`
text-xl font-semibold text-white
`;
const BtnWrapper = tw.div`w-full flex items-center justify-between`;
const FlexCol = tw.div`flex flex-col gap-0.5`;


export default ViewDetails;
